//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";

export default {
    name: "ViewAQSearch",
    components: {
        AQSkeleton
    },
    data() {
        return {
        };
    },
    computed: {
    }
};
